import classes from './logo.module.scss';
export const Logo = () => {
  return (
    <div className={classes.logo}>
      <div className={classes.logo_withoutText}>
        <svg
          width="24"
          height="32"
          viewBox="0 0 24 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 0V19.9989L11.9992 32L17.9994 20.0002L23.9997 19.9989V0H0Z"
            fill="#009286"
          />
          <path
            d="M11.999 32.0001L23.9995 19.999L11.999 7.99976V32.0001Z"
            fill="#F3C000"
          />
        </svg>
      </div>
      <div className={classes.logo_withText}>
        <svg
          width="129"
          height="32"
          viewBox="0 0 129 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 0V19.9989L11.9994 32L17.9997 20.0002L24 19.9989V0H0Z"
            fill="#009286"
          />
          <path d="M12 32.0001L24 19.999L12 7.99976V32.0001Z" fill="#F3C000" />
          <path
            d="M34.965 15.9294L35.7522 12.8504H39.7058L40.4737 15.9294H43.526L39.7639 2.03638H35.9443L32.1055 15.9294H34.965ZM39.092 10.7146H36.328L37.6523 4.7094H37.691L39.092 10.7146Z"
            fill="#939393"
          />
          <path
            d="M48.906 9.84845H50.5952C52.0537 9.84845 52.5147 10.599 52.5147 11.8316C52.5147 13.7742 51.1323 13.7936 50.5185 13.7936H48.906V9.84845ZM48.906 4.17156H50.6907C51.6694 4.17156 52.3612 4.92143 52.3612 5.94148C52.3612 7.28863 51.4779 7.71203 50.8448 7.71203H48.9066V4.17156H48.906ZM51.1323 15.9294C52.3612 15.9294 55.4128 15.7761 55.4128 12.2538C55.4128 10.3494 54.8758 9.02103 52.8216 8.73271V8.69456C54.3961 8.38686 55.1827 7.23172 55.1827 5.6344C55.1827 2.67119 53.3599 2.03577 51.1517 2.03577H46.0078V15.9287H51.1323V15.9294Z"
            fill="#939393"
          />
          <path
            d="M61.5022 15.9294V5.76824H61.5396L65.3211 15.9294H69.1413V2.03577H66.4346V11.6572H66.3959L62.7105 2.03577H58.7949V15.9294H61.5022Z"
            fill="#939393"
          />
          <path
            d="M73.6899 9.79404L75.5494 7.92905L73.6899 6.07031L71.8359 7.92905L73.6899 9.79404Z"
            fill="#939393"
          />
          <path
            d="M79.3396 15.9294L80.1262 12.8504H84.0799L84.8478 15.9294H87.9L84.1379 2.03638H80.3184L76.4795 15.9294H79.3396ZM83.4661 10.7146H80.702L82.0263 4.7094H82.065L83.4661 10.7146Z"
            fill="#939393"
          />
          <path
            d="M93.107 15.9294V5.211H93.145L95.6795 15.9294H98.4429L101.111 5.211H101.149V15.9294H103.972V2.03577H99.4604L97.1573 11.4839H97.1186L94.949 2.03577H90.2861V15.9294H93.107Z"
            fill="#939393"
          />
          <path
            d="M110.672 4.17155H111.957C112.879 4.17155 113.436 4.67188 113.436 5.99901C113.436 6.88397 113.109 8.03849 111.957 8.03849H110.672V4.17155ZM110.672 10.1755H111.421C113.647 10.1755 113.494 11.5796 113.494 13.2351C113.494 14.1407 113.417 15.0832 113.801 15.9294H116.641C116.373 15.3533 116.315 12.7347 116.315 11.8498C116.315 9.34748 114.434 9.19425 113.8 9.11732V9.07918C115.681 8.77085 116.372 7.44372 116.372 5.67254C116.372 3.30597 115.105 2.03638 113.128 2.03638H107.773V15.9294H110.672L110.672 10.1755Z"
            fill="#939393"
          />
          <path
            d="M124.22 14.0837C122.589 14.0837 122.377 12.544 122.377 8.98409C122.377 5.42423 122.588 3.88445 124.22 3.88445C125.851 3.88445 126.062 5.42485 126.062 8.98409C126.062 12.5433 125.85 14.0837 124.22 14.0837ZM124.22 16.1614C129 16.1614 129 12.6209 129 8.98346C129 5.3079 129 1.80432 124.22 1.80432C119.44 1.80432 119.44 5.3079 119.44 8.98346C119.44 12.6203 119.44 16.1614 124.22 16.1614Z"
            fill="#939393"
          />
        </svg>
      </div>
      <div className={classes.logo_pointer}>
        <svg
          width="32"
          height="16"
          viewBox="0 0 32 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M16 16L0 0H32L16 16Z" fill="white" />
        </svg>
      </div>
    </div>
  );
};
